import reporting from './reporting';

export default {
    reporting: reporting
}